module.exports = __webpack_public_path__ + "7fbda4617a8c82cfeb45326c65b5e63f.pdf";